export enum UserImportStep{
    ImportTypeSelection = 1,
    FileUpload = 2,
    UserOptions = 3,
    Validation = 4,
    ReviewAndApplyChanges = 5
}